// extracted by mini-css-extract-plugin
export default {"pointable":"bG1_6","toggleIcon":"umMBo"};